import type { BossConfig } from '../../entities/BossConfig';

export const BEAR_CONFIG: BossConfig = {
  id: 'bear',
  displayName: 'Медведь',
  bossType: 'charging',

  maxHp: 250,
  speed: 0,
  movementBehavior: 'charging_boss',

  chargingParams: {
    idleMs: 1600,
    windupMs: 800,
    chargeSpeed: 420,
    recoveryMs: 1100,
    contactDamage: 0,
  },

  contactBehavior: 'instakill',
  instakillDragMs: 400,
  // По PROJECT.md (Босс №5): "Уязвим: всё время". invulnerableInPhases НЕ задаём,
  // glow по контуру на charge нет — пули проходят на всех фазах.

  // Run-spritesheet 3 кадра играет только на charge. В покое (idle/windup/
  // recovery) — стоп-кадр. Низ-по-центру origin для постановки лап.
  animateOnlyOnCharge: true,
  spriteOrigin: [0.5, 1],

  // Камень: 6-кадровая spritesheet анимация кувыркания (bear_rock_spin),
  // движком rotation НЕ крутим — поворот запечён в кадры. Полёт прямой
  // горизонтально (как плевок верблюда), useArc убран. По PROJECT.md
  // ("Камень: попадание = блокировка стрельбы на ~время перезарядки. НЕ
  // наносит урон по hp") — effectType = block_shooting (default),
  // blockDurationMs = ~2с (близко к перезарядке среднего оружия).
  // landSlimeConfig НЕ задан — слизь спавнится не от камня, а от конца
  // charge через slimeAttack (см. ниже), как требует PROJECT.md.
  // mouthOffsetX/Y — спавн "у руки" (форвард 80 от центра, выше центра на 40),
  // signed по chargeDirX. horizontalOnly → летит горизонтально в направлении
  // рывка, игнорируя y-координату игрока (тот дожен сместиться по Y чтобы уйти).
  projectileAttack: {
    enabled: true,
    throwInPhase: 'windup',
    projectileSpeed: 700,
    projectileSize: 16,
    projectileColor: 0x6b6b6b,
    blockDurationMs: 2000,
    throwEveryNthCycle: 2,
    textureKey: 'bear_rock',
    animKey: 'bear_rock_spin',
    spriteHeightPx: 40,
    horizontalOnly: true,
    // Скейлится пропорционально новому size=48 (раньше было 80/-40 при size=120).
    mouthOffsetX: 32,
    mouthOffsetY: -16,
  },

  // Слизь по PROJECT.md: спавн в точке конца charge ("точка промаха медведя"),
  // замедляет игрока (slowFactor 0.35), 5 одновременно (MAX_ZONES в GameScene),
  // FIFO старая удаляется новой, все исчезают со смертью босса (clearZones).
  // НЕ instakill (PROJECT.md: "замедление, не урон").
  // Уменьшено в 3 раза: 70→23 (collision), 140→46 (display).
  slimeAttack: {
    enabled: true,
    radius: 23,
    color: 0x5a7a3a,
    slowFactor: 0.35,
    textureKey: 'bear_slime',
    displayDiameterPx: 46,
    // lifetimeMs не задан → постоянная, до clearZones в onBossDefeated.
  },

  phases: {
    phase2HpThreshold: 0.66,
    phase3HpThreshold: 0.33,
    phase2: {
      throwEveryNthCycle: 1,
      idleMsMultiplier: 0.8,
    },
    phase3: {
      throwEveryNthCycle: 1,
      idleMsMultiplier: 0.6,
      chargeSpeedMultiplier: 1.15,
    },
  },

  isFinalBoss: true,

  // Уменьшено в 2.5 раза: 120→48. Спрайт display height = 48 × 2 × scale = 96 px
  // на 720p. Хитбокс 48×48. Лужа смерти ~96 px (через recordEnemyPuddle с size).
  size: 48,
  // baseColor для Rectangle-плейсхолдера (виден только если overlay-спрайт
  // не загрузится). phaseTints НЕ задан — медведь всегда в натуральных цветах
  // PNG, без цветовых сдвигов по фазам.
  color: 0x4a3520,

  scoreReward: 2000,
};
